var map = {
	"./air-conditioner.svg": 1428,
	"./airplane.svg": 1429,
	"./airport.svg": 1430,
	"./approved.svg": 1431,
	"./aquapark.svg": 1432,
	"./arrow-answer-bubble.svg": 1433,
	"./arrow-back.svg": 1434,
	"./arrow-flight.svg": 1435,
	"./arrow-right-top.svg": 1436,
	"./arrow-right.svg": 1437,
	"./bar.svg": 1438,
	"./beach-surface-pebble.svg": 1439,
	"./beach-surface-platform.svg": 1440,
	"./beach-surface-sand-pebble.svg": 1441,
	"./beach-surface-sand.svg": 1442,
	"./beachsurface.svg": 1443,
	"./card.svg": 1444,
	"./check.svg": 1445,
	"./clock.svg": 1446,
	"./cvv.svg": 1447,
	"./double-arrow.svg": 1448,
	"./empty-hotel-map.svg": 1449,
	"./filters/clear-filters.svg": 1450,
	"./filters/filter-button.svg": 1451,
	"./filters/instant-confirm-colored.svg": 1452,
	"./filters/instant-confirm.svg": 1453,
	"./filters/search-distance.svg": 1454,
	"./filters/search-lift.svg": 1455,
	"./fire.svg": 1456,
	"./flight-direct-mobile.svg": 1457,
	"./flight-direct.svg": 1458,
	"./flight-direct__additional-mobile.svg": 1459,
	"./flight-direct__additional.svg": 1460,
	"./flight-transition-mobile.svg": 1461,
	"./flight-transition.svg": 1462,
	"./flight-transition__additional-mobile.svg": 1463,
	"./flight-transition__additional.svg": 1464,
	"./food.svg": 1465,
	"./free-cancellation-colored.svg": 1466,
	"./fuel-green.svg": 1467,
	"./fuel-white.svg": 1468,
	"./funicular.svg": 1469,
	"./gallery-empty.svg": 1470,
	"./garranty.svg": 1471,
	"./gender-female.svg": 1472,
	"./gender-male.svg": 1473,
	"./gender-unidentified.svg": 1474,
	"./gift.svg": 1475,
	"./glass.svg": 1476,
	"./gym.svg": 1477,
	"./hand-luggage.svg": 1478,
	"./heated-pool.svg": 1479,
	"./hold-luggage.svg": 1480,
	"./hotel-reply.svg": 1481,
	"./included-services.svg": 1482,
	"./included.svg": 1483,
	"./kids-club.svg": 1484,
	"./kids-menu.svg": 1485,
	"./kids-pool.svg": 1486,
	"./lightning.svg": 1487,
	"./lock.svg": 1488,
	"./logo.svg": 1489,
	"./lt-extra/bonus_insurance.svg": 1490,
	"./lt-extra/bonus_ivi.svg": 1491,
	"./luggage-wrapping.svg": 1492,
	"./man.svg": 1493,
	"./map-button.svg": 1494,
	"./map/collapse-arrows.svg": 1495,
	"./map/expand-arrows.svg": 1496,
	"./massage.svg": 1497,
	"./nanny.svg": 1498,
	"./only-lt-half.svg": 1499,
	"./parking.svg": 1500,
	"./payment-mir.svg": 1501,
	"./paymenttype.svg": 1502,
	"./plane-arrival.svg": 1503,
	"./plane.svg": 1504,
	"./private-beach.svg": 1505,
	"./rest_types/active.svg": 1506,
	"./rest_types/couples.svg": 1507,
	"./rest_types/family.svg": 1508,
	"./review-tab-selected.svg": 1509,
	"./sauna.svg": 1510,
	"./search-sorting.svg": 1511,
	"./searcher-empty-request.svg": 1512,
	"./searcher-filtered-empty.svg": 1513,
	"./sidebar-bottom-triangle.svg": 1514,
	"./sidebar-menu-active.svg": 1515,
	"./sign_additional.svg": 1516,
	"./ski-in-ski-out.svg": 1517,
	"./social-fb.svg": 1518,
	"./social-share.svg": 1519,
	"./social-vk.svg": 1520,
	"./special.svg": 1521,
	"./success_additional.svg": 1522,
	"./swimming-pool.svg": 1523,
	"./thumbs-up.svg": 1524,
	"./wave.svg": 1525,
	"./wifi.svg": 1526
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 897;